module.exports = __webpack_public_path__ + "static/media/jo.58061676.svg";